/* eslint-disable max-len */
import React from 'react';

const EditImageIcon = () => (
  <svg width="40" height="40" viewBox="7 0 22 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.8528 13.541L23.7518 14.642L21.3568 12.246L22.4578 11.145C22.5558 11.048 22.6838 10.999 22.8108 10.999C22.9388 10.999 23.0668 11.048 23.1648 11.145L24.8528 12.833C25.0478 13.028 25.0478 13.346 24.8528 13.541ZM14.1898 24.204C14.1188 24.274 14.0278 24.322 13.9298 24.342L11.1278 24.871L11.6578 22.068C11.6758 21.97 11.7228 21.88 11.7948 21.809L20.6498 12.953L23.0448 15.349L14.1898 24.204ZM25.5598 12.126L23.8718 10.438C23.2868 9.854 22.3358 9.854 21.7508 10.438L11.0878 21.101C10.8738 21.315 10.7298 21.586 10.6748 21.884L10.0088 25.405C9.9778 25.567 10.0298 25.734 10.1468 25.852C10.2418 25.946 10.3688 25.998 10.4998 25.998C10.5308 25.998 10.5618 25.995 10.5928 25.989L14.1168 25.324C14.4148 25.267 14.6858 25.123 14.8968 24.91L25.5598 14.248C26.1448 13.663 26.1448 12.711 25.5598 12.126Z"
      fill="currentColor"
    />
  </svg>
);

export default EditImageIcon;
